module.exports = __webpack_public_path__ + "static/media/off-icon.4bf3e335.png";